import TopTicker from '@/pages/home/components/TopTicker';
import SiteHeader from '@/pages/home/components/SiteHeader';
import Hero from '@/pages/home/components/Hero';
import EntryIndex from '@/pages/home/components/EntryIndex';
import UpdateFeed from '@/pages/home/components/UpdateFeed';
import TopicWall from '@/pages/home/components/TopicWall';
import CoverWall from '@/pages/home/components/CoverWall';
import FixSteps from '@/pages/home/components/FixSteps';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopTicker />
      <SiteHeader />
      <main>
        <Hero />
        <EntryIndex />
        <UpdateFeed />
        <TopicWall />
        <CoverWall />
        <FixSteps />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}